<script setup lang="ts">
import Button from '@/components/ui/Button.vue'
const emit = defineEmits({
  continue: () => true,
})

const onClickContinue = () => {
  emit('continue')
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-xl p-8 max-w-2xl w-full text-center">
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-4">
          Greatly Health has helped 1000s of people like you
        </h1>
        <div
          class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
        </div>
        <p class="text-gray-600">You're taking an important step towards better health</p>
      </div>
      <Button variant="primary" full-width @click="onClickContinue">Continue</Button>
    </div>
  </div>
</template>

<style scoped></style>
